export const WHATSAPP_NUMBER = "919566853582";

export function waLink(message) {
  const url = `https://wa.me/${WHATSAPP_NUMBER}`;
  return message ? `${url}?text=${encodeURIComponent(message)}` : url;
}

function itemLine(it, i) {
  const parts = [`${i + 1}. ${it.product_name}`];
  if (it.size) parts.push(`Size: ${it.size}`);
  if (it.color) parts.push(`Colour: ${it.color}`);
  if (it.quantity) parts.push(`Qty: ${it.quantity}`);
  if (it.printing_method) parts.push(`Print: ${it.printing_method}`);
  if (it.custom_text) parts.push(`Text: "${it.custom_text}"`);
  if (it.custom_name) parts.push(`Name: ${it.custom_name}`);
  if (it.custom_number) parts.push(`Number: ${it.custom_number}`);
  if (it.design_id) parts.push(`Design: ${it.design_id}`);
  return parts.join(" | ");
}

export function cartWhatsAppMessage(items) {
  if (!items?.length) return "Hi PrintMyTees, I want to place an order.";
  const lines = items.map(itemLine);
  return `Hi PrintMyTees, I want to place an order:\n\n${lines.join("\n")}\n\nPlease share a quote.`;
}

export function orderWhatsAppMessage(order) {
  if (!order) return "Hi PrintMyTees, I just placed an order.";
  const lines = (order.items || []).map(itemLine);
  return [
    `Hi PrintMyTees, I have just placed order ${order.order_number}.`,
    ``,
    `Items:`,
    ...lines,
    ``,
    `Please confirm my order.`,
  ].join("\n");
}
